module.exports = __webpack_public_path__ + "static/img/10.5a9c4bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/10.png
// module id = 0bOp
// module chunks = 0